import React from "react"
import * as styles from "./ContactSection.module.css"
import edgeLogo from "../../images/on-going-projects/the-edge/gallery/edge-logo.png"

const ContactSection = () => {
  return (
    <section className={styles.contactSection} id="location">
      <div className={styles.sectionWrapper}>
        {/* HEADING */}
        <h2 className={styles.sectionHeading}>Project <span className={styles.cbr}>Location</span></h2>
        
        <div className={styles.contactContainer}>
          {/* LOGO & ADDRESS */}
          <div className={`${styles.addressContainer} ${styles.fadeInLeft}`}>
            <div className={styles.logoWrapper}>
              <img src={edgeLogo} alt="The Edge Logo" className={styles.edgeLogo} />
            </div>
            <div className={styles.addressInfo}>
              <p>
                <i className="fas fa-map-marker-alt"></i> Old Door No.30, Door No. 14, New, Padmavathy Thayar Street, Gopalapuram, Chennai, Tamil Nadu 600086, India
              </p>
            </div>
          </div>

          {/* MAP */}
          <div className={`${styles.contactMap} ${styles.fadeInRight}`}>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15547.09812563869!2d80.2578659896089!3d13.0500187685929!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526777017c9701%3A0x39f0c7473f9b635b!2sThe%20Edge%20-%20Baashyaam%20Constructions!5e0!3m2!1sen!2sin!4v1769248163258!5m2!1sen!2sin"
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy"
              title="Location Map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactSection
